import {Component} from "@angular/core";

@Component({
    selector: "fui-prepend-field",
    styleUrls: ["./prepend-field.component.scss"],
    templateUrl: "./prepend-field.component.html",
    standalone: false
})
export class FUIPrependFieldComponent {

}
